'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
require('../../enums/accordion.js');
require('../../enums/alert.js');
require('../../enums/avatar.js');
require('../../enums/breakpoints.js');
require('../../enums/button.js');
require('../../enums/code-editor.js');
var colors = require('../../enums/colors.js');
require('../../enums/combobox.js');
require('../../enums/date.js');
require('../../enums/drag-and-drop.js');
require('../../enums/dialog.js');
require('../../enums/divider.js');
require('../../enums/dropdown.js');
require('../../enums/fieldset.js');
require('../../enums/font-icon.js');
var fonts = require('../../enums/fonts.js');
require('../../enums/headings.js');
require('../../enums/input.js');
require('../../enums/keys.js');
require('../../enums/list.js');
require('../../enums/listbox.js');
require('../../enums/loader.js');
require('../../enums/margin.js');
require('../../enums/option.js');
require('../../enums/pill.js');
require('../../enums/placements.js');
require('../../enums/popout.js');
require('../../enums/privacy.js');
require('../../enums/radio-group.js');
require('../../enums/status.js');
require('../../enums/switch.js');
require('../../enums/table.js');
require('../../enums/tooltip.js');
require('../../enums/transitions.js');
require('../../enums/widths.js');
require('../../themes/alert.js');
require('../../themes/button.js');
require('../../themes/checkbox.js');
require('../../themes/divider.js');
require('../../themes/dropdown.js');
require('../../themes/fieldset.js');
var fonts$1 = require('../../themes/fonts.js');
require('../../themes/input.js');
require('../../themes/list.js');
require('../../themes/listbox.js');
require('../../themes/loader.js');
require('../../themes/option.js');
require('../../themes/popout.js');
require('../../themes/switch.js');
require('../../themes/themes.js');
require('../../themes/tooltip.js');

const getFontAlignment = (options)=>{
    const { align  } = options;
    switch(align){
        case fonts.FontAlignments.Center:
            {
                return styled.css`
        text-align: center;
      `;
            }
        case fonts.FontAlignments.Right:
            {
                // prefer `text-align: end` over `text-align: right` for RTL support
                return styled.css`
        text-align: end;
      `;
            }
        // FontAlignments.Left
        default:
            {
                // prefer `text-align: start` over `text-align: left` for RTL support
                return styled.css`
        text-align: start;
      `;
            }
    }
};
const getFontColor = (options)=>{
    const { color , darkMode  } = options;
    switch(color){
        case fonts.FontColors.Primary:
            {
                return styled.css`
        color: ${colors.BrandfolderHexColors.PurplePopsicle};
      `;
            }
        case fonts.FontColors.Warning:
            {
                return styled.css`
        color: ${colors.BrandfolderHexColors.WarningRed};
      `;
            }
        // FontColors.Default
        default:
            {
                return styled.css`
        color: ${darkMode ? colors.BrandfolderHexColors.White : colors.BrandfolderHexColors.Text};
      `;
            }
    }
};
const getFontDecoration = (options)=>{
    const { decoration  } = options;
    switch(decoration){
        case fonts.FontDecorations.Dotted:
            {
                return styled.css`
        text-decoration: dotted underline;
      `;
            }
        case fonts.FontDecorations.Underline:
            {
                return styled.css`
        text-decoration: underline;
      `;
            }
        default:
            {
                return styled.css``;
            }
    }
};
const getFontWeight = (options)=>{
    const { italic , weight  } = options;
    const fontStyle = italic ? styled.css`
        font-style: italic;
      ` : styled.css``;
    switch(weight){
        case fonts.FontWeights.Bold:
            {
                return styled.css`
        font-family: ${fonts$1.fontFamilyBold};
        font-weight: ${fonts$1.fontWeightBold};
      `;
            }
        case fonts.FontWeights.Book:
            {
                return styled.css`
        font-family: ${italic ? fonts$1.fontFamilyBookItalic : fonts$1.fontFamilyBook};
        ${fontStyle}
        font-weight: ${fonts$1.fontWeightBook};
      `;
            }
        case fonts.FontWeights.Medium:
            {
                return styled.css`
        font-family: ${italic ? fonts$1.fontFamilyMediumItalic : fonts$1.fontFamilyMedium};
        ${fontStyle}
        font-weight: ${fonts$1.fontWeightMedium};
      `;
            }
        default:
            {
                return styled.css``;
            }
    }
};
const getFontSize = (options)=>{
    const { size  } = options;
    switch(size){
        case fonts.FontSizes.Large:
            {
                return styled.css`
        font-size: ${fonts$1.fontSizeLarge}px;
        line-height: 28px;
      `;
            }
        case fonts.FontSizes.Small:
            {
                return styled.css`
        font-size: ${fonts$1.fontSizeSmall}px;
        line-height: 22px;
      `;
            }
        case fonts.FontSizes.Medium:
            {
                return styled.css`
        font-size: ${fonts$1.fontSizeMedium}px;
        line-height: 24px;
      `;
            }
        case fonts.FontSizes.XLarge:
            {
                return styled.css`
        font-size: ${fonts$1.fontSizeXLarge}px;
        line-height: 40px;
      `;
            }
        case fonts.FontSizes.XSmall:
            {
                return styled.css`
        font-size: ${fonts$1.fontSizeXSmall}px;
        line-height: 20px;
      `;
            }
        case fonts.FontSizes.XxLarge:
            {
                return styled.css`
        font-size: ${fonts$1.fontSizeXxLarge}px;
        line-height: 50px;
      `;
            }
        case fonts.FontSizes.XxSmall:
            {
                return styled.css`
        font-size: ${fonts$1.fontSizeXxSmall}px;
        line-height: 18px;
      `;
            }
        default:
            {
                return styled.css``;
            }
    }
};
const getFontTransform = (options)=>{
    const { transform  } = options;
    switch(transform){
        case fonts.FontTransforms.Capitalize:
            {
                return styled.css`
        text-transform: capitalize;
      `;
            }
        case fonts.FontTransforms.Lowercase:
            {
                return styled.css`
        text-transform: lowercase;
      `;
            }
        case fonts.FontTransforms.Uppercase:
            {
                return styled.css`
        text-transform: uppercase;
      `;
            }
        default:
            {
                return styled.css``;
            }
    }
};

exports.getFontAlignment = getFontAlignment;
exports.getFontColor = getFontColor;
exports.getFontDecoration = getFontDecoration;
exports.getFontSize = getFontSize;
exports.getFontTransform = getFontTransform;
exports.getFontWeight = getFontWeight;
//# sourceMappingURL=font.js.map
